// Currency configuration and utilities
export const CURRENCIES = {
  INR: {
    code: 'INR', symbol: '₹', name: 'Indian Rupee', position: 'before', decimalPlaces: 2, exchangeRate: 1,
  },
  USD: {
    code: 'USD', symbol: '$', name: 'US Dollar', position: 'before', decimalPlaces: 2, exchangeRate: 0.012,
  },
  EUR: {
    code: 'EUR', symbol: '€', name: 'Euro', position: 'before', decimalPlaces: 2, exchangeRate: 0.011,
  },
  GBP: {
    code: 'GBP', symbol: '£', name: 'British Pound', position: 'before', decimalPlaces: 2, exchangeRate: 0.0095,
  },
  CAD: {
    code: 'CAD', symbol: 'C$', name: 'Canadian Dollar', position: 'before', decimalPlaces: 2, exchangeRate: 0.016,
  },
  AUD: {
    code: 'AUD', symbol: 'A$', name: 'Australian Dollar', position: 'before', decimalPlaces: 2, exchangeRate: 0.018,
  },
  JPY: {
    code: 'JPY', symbol: '¥', name: 'Japanese Yen', position: 'before', decimalPlaces: 0, exchangeRate: 1.8,
  },
  AED: {
    code: 'AED', symbol: 'د.إ', name: 'UAE Dirham', position: 'before', decimalPlaces: 2, exchangeRate: 0.044,
  },
  SAR: {
    code: 'SAR', symbol: 'ر.س', name: 'Saudi Riyal', position: 'before', decimalPlaces: 2, exchangeRate: 0.045,
  },
  CNY: {
    code: 'CNY', symbol: '¥', name: 'Chinese Yuan', position: 'before', decimalPlaces: 2, exchangeRate: 0.087,
  },
  NPR: {
    code: 'NPR', symbol: 'रू', name: 'Nepalese Rupee', position: 'before', decimalPlaces: 2, exchangeRate: 1.6,
  }
};

export const getCurrentCurrency = () => {
  try {
    const stored = localStorage.getItem('selectedCurrency');
    return stored && CURRENCIES[stored] ? stored : 'INR';
  } catch (error) {
    return 'INR';
  }
};

export const setCurrentCurrency = (currencyCode) => {
  try {
    if (CURRENCIES[currencyCode]) {
      localStorage.setItem('selectedCurrency', currencyCode);
      return true;
    }
    return false;
  } catch (error) {
    return false;
  }
};

export const convertPrice = (priceInINR, targetCurrency = null) => {
  const currentCurrency = targetCurrency || getCurrentCurrency();
  const currency = CURRENCIES[currentCurrency];
  if (!currency) return priceInINR;
  return priceInINR * currency.exchangeRate;
};

// Updated formatPrice function that works with Redux state
export const formatPrice = (price, currencyCode = null) => {
  const currentCurrency = currencyCode || getCurrentCurrency();
  const currency = CURRENCIES[currentCurrency];
  if (!currency) return `₹${price.toFixed(2)}`;
  
  // Convert price from INR to target currency
  const convertedPrice = price * currency.exchangeRate;
  const formattedAmount = convertedPrice.toFixed(currency.decimalPlaces);
  
  return currency.position === 'before'
    ? `${currency.symbol}${formattedAmount}`
    : `${formattedAmount}${currency.symbol}`;
};

// New function to format price with Redux state
export const formatPriceWithRedux = (price, currentCurrency) => {
  const currency = CURRENCIES[currentCurrency];
  if (!currency) return `₹${price.toFixed(2)}`;
  
  // Convert price from INR to target currency
  const convertedPrice = price * currency.exchangeRate;
  const formattedAmount = convertedPrice.toFixed(currency.decimalPlaces);
  
  return currency.position === 'before'
    ? `${currency.symbol}${formattedAmount}`
    : `${formattedAmount}${currency.symbol}`;
};

export const getCurrencyOptions = () => {
  return Object.values(CURRENCIES).map(currency => ({
    value: currency.code,
    label: `${currency.symbol} ${currency.name} (${currency.code})`
  }));
};

export const getCurrencyInfo = (currencyCode = null) => {
  const currentCurrency = currencyCode || getCurrentCurrency();
  return CURRENCIES[currentCurrency] || CURRENCIES.INR;
}; 